import { Typography, message, Input, Row, Col } from "antd";
import { useState, useEffect } from "react";
import UserAdminIndex from "./UserAdminIndex";
import axios from "axios";
import { useAuth } from "../../layout/auth"; // Assuming auth context is needed

export default function UserAdmin() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const auth = useAuth(); // Assuming auth context is needed

  const fetchUsers = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/usuarios`)
      .then((res) => {
        setUsers(res.data);
        setFilteredUsers(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = users.filter((user) => {
        return (
          user?.nombre?.toLowerCase().includes(search.toLowerCase()) ||
          user?.apellido?.toLowerCase().includes(search.toLowerCase()) ||
          user?.email?.toLowerCase().includes(search.toLowerCase()) ||
          user?.rol?.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(users);
    }
  }, [search, users]);

  return (
    <div>
      <Typography.Title level={3} type="secondary">
        Administración de Usuarios
      </Typography.Title>
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Input.Search placeholder="Buscar usuarios" onSearch={(value) => setSearch(value)} enterButton="Buscar" loading={loading} />
        </Col>
      </Row>
      <UserAdminIndex users={filteredUsers} loading={loading} onUpdateSuccess={fetchUsers} />
    </div>
  );
}
